import appApi from "../apis/appApi";

export default {
    namespaced: true,
    state: {
        isLoading: false,
        apps: null,
    },
    getters: {
        appsLoaded(state) {
            return state.apps !== null;
        },
        getAppById: (state, getters) => (id) => {
            if (!getters.appsLoaded)
                return [];
            return state.apps.find(app => app.id === id);
        },
    },
    mutations: {
        setIsLoading(state, isLoading) {
            state.isLoading = isLoading;
        },
        setApps(state, apps) {
            state.apps = apps;
        }
    },
    actions: {
        loadApps({commit}) {
            commit('setIsLoading', true);

            return appApi.index()
                .then(apps => {
                    commit('setApps', apps);
                    return apps;
                })
                .finally(() => {
                    commit('setIsLoading', false);
                })
        }
    }
}
